import { CSSProperties, FC } from 'react';

import { fontSizes, HAlignEnum, VAlignEnum } from '@/settings/text-settings';

type TextContentProps = {
  text: string;
};

const TextContent: FC<TextContentProps> = ({ text }) => {
  const TextAreaStyles = () => {
    const resultStyles: CSSProperties = {};
    resultStyles.textAlign = HAlignEnum.LEFT;
    resultStyles.fontWeight = 'normal';
    resultStyles.fontStyle = 'normal';

    resultStyles.color = 'black';

    if (window.matchMedia('(min-width: 1280px)').matches) {
      resultStyles.fontSize = fontSizes['M'].md;
    } else {
      resultStyles.fontSize = fontSizes['M'].sm;
    }
    return resultStyles;
  };
  return (
    <div
      className="w-full h-full max-h-[70dvh] md:max-w-[70dvw] flex flex-col py-4"
      style={{
        justifyContent: VAlignEnum.TOP,
        backgroundColor: 'white',
      }}
    >
      <div
        style={TextAreaStyles()}
        className="outline-none custom-scrollbar-thin overflow-y-auto w-full h-full md:px-4 px-2 bg-transparent rounded-md whitespace-pre-wrap break-words focus:outline-none"
        onWheel={(e) => e.stopPropagation()}
        contentEditable={false}
        dangerouslySetInnerHTML={{ __html: text }}
      ></div>
    </div>
  );
};

export default TextContent;
